// Values taken from CDatabaseDataConst.java
export enum RecordingIntegrations {
    NONE = 'd7ae7ea9bf56ebdc:-53beea96:1556d0e14d3:-8000',
    INVALID = 'd7ae7ea9bf56ebdc:-53beea96:1556d0e14d3:-7fff'
}
